module.exports = __webpack_public_path__ + "static/media/flex-mockup.9d65743e.png";